<template>
  <div class="calendar"
    @wheel.passive="handleWheel"
    ref="calendaryear">
      <YearItem
        @touchstart.passive="handleTouchStart($event, index)"
        @touchmove.passive="handleTouchMove($event)"
        @touchend.passive="handleTouchEnd()" 
        :style="{
          'transform': `translateY(${year.yposition}px)`
        }" 
        @set-month="setMonth"
        :daysOfWeek="daysOfWeek"
        :key="year"
        :months="year.months"
        :year="year"
        v-for="year in visibleYears" />
  </div>
</template>

<script>
import YearItem from "@/components/calendarScroller/yearItem.vue";

const DRAGUP = -1;
const DRAGDOWN = 1;

export default {
  name: 'YearDragger',
  props:["yearsInRange","currentYear","limitYears"],
  components:{
    YearItem
  },
  data() {
    const daysOfWeek = ["S", "T", "Q", "Q", "S", "S", "D"];
    return {
      daysOfWeek,
      isDragging: false,
      draggedIndex: 0,
      dragStartY: 0,
      velocity: 0,
      inertiaInterval: null,
      lastTouchY: 0,
      lastTouchTime: 0,
      progress: 0,
      startTime:0,
      currentYPosition: 0,
    }
  },
  computed:{
    visibleYears() {
      if(this.limitYears){
        return [...this.yearsInRange];
      }
      const sortedYears = [...this.yearsInRange];
      let closestIndex = -3;
      let closestDiff = Infinity;
      sortedYears.forEach((year, index) => {
        const diff = Math.abs(year.yposition - this.progress);
        if (diff < closestDiff) {
          closestDiff = diff;
          closestIndex = index;
        }
      });
      /*se alterar estes valores não está a gerar os anos maiores*/
      const bufferBefore = 2;
      const bufferAfter = 3;
      return sortedYears.slice(
        Math.max(closestIndex - bufferBefore, 0),
        closestIndex + bufferAfter,
      );
    },
  },
  methods: {
    debounce(fn, delay) {
      let timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, arguments), delay);
      };
    },
    setMonth(data){
      this.$emit('setMonth',data);
    },
    emitVisibleMonths() {
      /*const monthElements = this.visibleYears.map(month => {
        return {
          years: month.year,
          element: this.$refs[`${month.month}${month.year}`][0]
        };
      });
      this.$emit('visible-months', monthElements);*/
    },
    handleWheel(event) {
      const scrollDirection = event.deltaY < 0 ? DRAGUP : DRAGDOWN;
      const scrollDistance = Math.abs(event.deltaY) * 3;
      this.moveElements(scrollDistance, scrollDirection);
    },
    handleTouchStart(event, index) {
      this.dragStartY = event.touches[0].clientY;
      this.lastTouchY = this.dragStartY;
      this.draggedIndex = index;
      this.startTime = performance.now();
      this.lastTouchTime = this.startTime;
      if (this.inertiaInterval) {
        clearInterval(this.inertiaInterval);
        this.inertiaInterval = null;
        this.velocity = 0; // Reset the velocity to stop the scrolling immediately
      }
    },
    handleTouchMove(event) {
      this.handleTouchBaseOnLastPosition(event);
    },
    handleTouchBaseOnLastPosition(event){
      const currentTouchY = event.touches[0].clientY;
      const dragDirection = currentTouchY < this.lastTouchY ? DRAGUP : DRAGDOWN;
      const dragDistance = Math.abs(currentTouchY - this.lastTouchY);
      this.moveElements(dragDistance, dragDirection);
      this.calculateVelocity(currentTouchY);
      this.$nextTick(()=>{
          this.emitVisibleMonths();
      })    
    },
    handleTouchEnd() {
      this.applyInertiaEffect();
    },
    calculateVelocity(clientY){
      const currentTime = performance.now();
      const timeDelta = currentTime - this.lastTouchTime;
      this.velocity = (clientY - this.lastTouchY) / timeDelta * 300; // Multiply by 1000 to adjust the scroll speed
      this.lastTouchY = clientY;
      this.lastTouchTime = currentTime;
    },
    applyInertiaEffect() {
      const friction = 0.94; // Adjust this value for more or less friction
      this.inertiaInterval = setInterval(() => {
        if (Math.abs(this.velocity) <= 0.1) {
          clearInterval(this.inertiaInterval);
          this.inertiaInterval = null;
          return;
        }
        const dragDirection = this.velocity < 0 ? DRAGUP : DRAGDOWN;
        const dragDistance = Math.abs(this.velocity);
        this.moveElements(dragDistance, dragDirection);
        this.$nextTick(()=>{
          this.emitVisibleMonths();
        })
        if (dragDirection == DRAGUP) {
          this.velocity = Math.min(0, this.velocity * friction);
        } else {
          this.velocity = Math.max(0, this.velocity * friction);
        }
      }, 16); // Update every ~16ms to match 60fps
    },
    moveElements(dragDistance, dragDirection) {
      const updatedPosition = this.currentYPosition + (dragDistance * dragDirection) * 0.10;
      const firstYearItem = this.yearsInRange[0].yposition;
      const lastYearItem = this.yearsInRange[this.yearsInRange.length - 1].yposition;
      let newPosition = updatedPosition;
      if (this.limitYears) {
        if (this.isDragNextYearAndCurrentPositionLargerThanLastYear(dragDirection,updatedPosition,lastYearItem)) {
          newPosition = lastYearItem * -1 - 200;
        } else if (this.isDragPreviousYearAndCurrentPositionIsSmallerThanFirstPosition(dragDirection,updatedPosition,firstYearItem)) {
          newPosition = firstYearItem * -1;
        }
      }
      requestAnimationFrame(() => {
        if(this.$refs.calendaryear != null){
          this.$refs.calendaryear.style.transform = `translateY(${newPosition}px)`;
        }
      });
      this.currentYPosition = newPosition;
      this.progress = this.currentYPosition * -1;
    },
    isDragNextYearAndCurrentPositionLargerThanLastYear(dragDirection,updatedPosition,lastYearItem){
      return dragDirection === DRAGUP && Math.abs(updatedPosition) > lastYearItem
    },
    isDragPreviousYearAndCurrentPositionIsSmallerThanFirstPosition(dragDirection,updatedPosition,firstYearItem){
      return dragDirection === DRAGDOWN && updatedPosition > Math.abs(firstYearItem);
    } 
  },

}
</script>

<style scoped>

.calendar {
  overflow-y: visible;
  height: 63vh;
  padding: 16px;
  padding-left: 0;
  padding-right: 0;
  -ms-overflow-style: none;
  scrollbar-width: none; 
  position: relative;
}

.calendar::-webkit-scrollbar {
  display: none;
}
</style>